import { render, staticRenderFns } from "./modif_modal.vue?vue&type=template&id=6c5313a8&scoped=true&"
import script from "./modif_modal.vue?vue&type=script&lang=js&"
export * from "./modif_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5313a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c5313a8')) {
      api.createRecord('6c5313a8', component.options)
    } else {
      api.reload('6c5313a8', component.options)
    }
    module.hot.accept("./modif_modal.vue?vue&type=template&id=6c5313a8&scoped=true&", function () {
      api.rerender('6c5313a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/items/modif_modal.vue"
export default component.exports